/**
 * Which bookmarks to retitle after page labels change (rename one page in
 * Thumbnails, or Reset page numbers).
 *
 * A new bookmark is titled "page <label>". Only a bookmark still holding that
 * default for its page's OLD label follows the new label; one the person has
 * renamed keeps its name. Before 11 Oct 2026 every bookmark on a relabelled page
 * was overwritten (Josh, sandbox QA).
 *
 * bookmarks: { [pageNumber]: title }   (pageNumber is 1-based, as stored)
 * oldLabels / newLabels: label strings indexed by page - 1
 * Returns [{ page, title }] for updateBookmark.
 */
export function bookmarkRenames(bookmarks, oldLabels, newLabels) {
    if (!bookmarks || typeof bookmarks !== 'object') return [];
    const renames = [];
    for (const [page, title] of Object.entries(bookmarks)) {
        const i = Number(page) - 1;
        const known = i in newLabels && i in oldLabels;
        const changed = known && `${oldLabels[i]}` !== `${newLabels[i]}`;
        if (changed && title === 'page ' + oldLabels[i]) {
            renames.push({ page, title: 'page ' + newLabels[i] });
        }
    }
    return renames;
}

export default { bookmarkRenames };


// WEBPACK FOOTER //
// ./src/lib/bookmark-labels.js